/** Case scenario PDF upload rules — PDF only, 10 MB max. */
export const CASE_SCENARIO_PDF_MAX_BYTES = 10 * 1024 * 1024;
export const CASE_SCENARIO_PDF_SIZE_LIMIT_LABEL = '10 MB';
export const CASE_SCENARIO_PDF_ACCEPT = '.pdf,application/pdf';

const ALLOWED_EXTENSIONS = new Set(['.pdf']);
const ALLOWED_MIME_TYPES = new Set(['application/pdf']);

export const CASE_SCENARIO_PDF_SIZE_ERROR = `The selected file exceeds the maximum upload size of ${CASE_SCENARIO_PDF_SIZE_LIMIT_LABEL}.`;
export const CASE_SCENARIO_PDF_TYPE_ERROR = 'The selected file type is not supported. Please upload a PDF file.';

function fileExtension(name: string): string {
  const i = name.lastIndexOf('.');
  return i >= 0 ? name.slice(i).toLowerCase() : '';
}

export function isAllowedCaseScenarioPdf(file: File): boolean {
  const ext = fileExtension(file.name);
  if (ext && ALLOWED_EXTENSIONS.has(ext)) return true;
  const mime = file.type.trim().toLowerCase();
  return Boolean(mime && ALLOWED_MIME_TYPES.has(mime));
}

export function validateCaseScenarioPdf(file: File): { ok: true } | { ok: false; message: string } {
  if (file.size > CASE_SCENARIO_PDF_MAX_BYTES) {
    return { ok: false, message: CASE_SCENARIO_PDF_SIZE_ERROR };
  }
  if (!isAllowedCaseScenarioPdf(file)) {
    return { ok: false, message: CASE_SCENARIO_PDF_TYPE_ERROR };
  }
  return { ok: true };
}
